import BaseSchema from "./schema";
const Mixed = BaseSchema;
export default Mixed;
export function create() {
  return new Mixed();
}
create.prototype = Mixed.prototype;
